import type { FC } from 'react';

import { useCodigoDoEmail } from '../../../logica/auth/useCodigoDoEmail';
import { CodigoDoEmail } from './CodigoDoEmail';

// O passo do código com a lógica ligada. Monta só quando chega a vez dele: `reenviarAoAbrir`
// dispara o envio na montagem (no login, o código do cadastro pode ter expirado).
export const CodigoDoEmailLigado: FC<{ email: string; aoConfirmar: () => void; reenviarAoAbrir?: boolean }> = ({
  email, aoConfirmar, reenviarAoAbrir,
}) => {
  const c = useCodigoDoEmail(email, aoConfirmar, reenviarAoAbrir);
  return <CodigoDoEmail email={email} {...c} />;
};
